// extracted by mini-css-extract-plugin
module.exports = {"search":"search_search__3gp0S","icon":"search_icon__KT4B8","input":"search_input__kKIKi","button":"search_button__34dar"};